import API_URL from './api';
import { useState } from 'react';
import './App.css';

function FolderPicker({ pinId, folders, userData, onMove, onCancel, onFolderCreated }) {
  const [creating, setCreating] = useState(false);
  const [newFolderName, setNewFolderName] = useState('');

  async function createFolderAndMove() {
    if (!newFolderName) return;
    try {
      const res = await fetch(`${API_URL}/api/folders`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: newFolderName, systemPrompt: '', token: userData.token }),
      });
      const data = await res.json();
      if (res.ok) {
        if (onFolderCreated) onFolderCreated();
        onMove(pinId, data.folder.id);
        setCreating(false);
        setNewFolderName('');
      }
    } catch (err) {
      console.error('Could not create folder:', err);
    }
  }

  if (creating) {
    return (
      <div className="folder-picker">
        <input
          type="text"
          className="inline-folder-input"
          placeholder="New chapter name..."
          value={newFolderName}
          onChange={(e) => setNewFolderName(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && createFolderAndMove()}
          autoFocus
        />
        <button className="move-btn" onClick={createFolderAndMove}>Create</button>
        <button className="cancel-btn" onClick={() => setCreating(false)}>Cancel</button>
      </div>
    );
  }

  return (
    <div className="folder-picker">
      <select
        defaultValue=""
        onChange={(e) => {
          if (e.target.value === 'new') {
            setCreating(true);
          } else if (e.target.value === 'inbox') {
            onMove(pinId, null);
          } else if (e.target.value) {
            onMove(pinId, e.target.value);
          }
        }}
      >
        <option value="" disabled>Change to...</option>
        {folders.map(f => (
          <option key={f.id} value={f.id}>{f.name}</option>
        ))}
        <option value="inbox">Inbox</option>
        <option value="new">+ Create new chapter...</option>
      </select>
      <button className="cancel-btn" onClick={onCancel}>Cancel</button>
    </div>
  );
}

export default FolderPicker;